export const ALLOWED_TYPES = [
  'image/png',
  'image/jpeg',
  'image/apng',
  'image/gif',
  'image/webp',
  'image/avif',
];
